import React from 'react';
import PropTypes from 'prop-types';
import styles from '../SearchWidget.module.scss';
import {withTranslation} from "react-i18next";

const ExternalLinks = ({visible, children, t}) => {

    if (!visible) return null;

    const containerClasses = [styles.externalLinksContainer];

    return (
        <div className={containerClasses.join(' ')} id={'search-widget-header-links'}>
            <a target={'_blank'}
               href={'https://' + t('www.booking.com/index.html?aid=363553&label=sata-homepage-sb')}>
                <i className={'icon-hotels'}/>&nbsp;{t('Hotel')}
            </a>
            <a target={'_blank'}
               href={'https://' + t('www.rentalcars.com/?affiliateCode=azoresairlines&preflang=en')}>
                <i className={'icomoon-parking'}/>&nbsp;{t('Car')}
            </a>
            <a target={'_blank'}
               href={'https://' + t('sataazores.parkcloud.com/en-GB?utm_source=sataazores_PT&utm_medium=referral&utm_campaign=home_page_nav')}>
                <i className={'icon-car'}/>&nbsp;{t('Park')}
            </a>
            <a target={'_blank'}
               href={'https://' + t('azoresgetaways.com/us/experiences?affiliateCode=azoresairlines')}>
                <i className={'icon-sata-hiking'}/>&nbsp;{t('Activities')}
            </a>
            {children}
        </div>
    );
};

ExternalLinks.propTypes = {
    children: PropTypes.any,
    visible: PropTypes.bool,
    t: PropTypes.func,
};

ExternalLinks.defaultProps = {
    children: null,
    visible: true,
    t: s => s,
};

export default withTranslation()(ExternalLinks);
